import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { putRequest, deleteRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import waitingImg from '../../../assets/images/waiting_for_candidates.png';
import './ProjectStatusActions.scss';

class ProjectStatusActions extends Component {
  constructor(props) {
    super(props);
    this.handleSubmitToClora = this.handleSubmitToClora.bind(this);
    this.handleDeleteProject = this.handleDeleteProject.bind(this);
    this.handleRetractSubmission = this.handleRetractSubmission.bind(this);
  }

  handleSubmitToClora() {
    const { submitToCloraUrl, csrfToken } = this.props;

    return putRequest(
      submitToCloraUrl,
      {},
      csrfToken,
    ).then(() => {
      analyticsTrack('Clicked on Publish', { location: 'Project View' });
      window.location.href = `${window.location.href}?published=true`;
    });
  }

  handleDeleteProject() {
    const { projectUrl, projectsUrl, csrfToken } = this.props;

    return deleteRequest(
      projectUrl,
      csrfToken,
    ).then(() => {
      window.location.href = projectsUrl;
    });
  }

  handleRetractSubmission() {
    const { retractSubmissionUrl, projectUrl, csrfToken } = this.props;

    return putRequest(
      retractSubmissionUrl,
      {},
      csrfToken,
    ).then(() => {
      window.location.href = projectUrl;
    });
  }

  render() {
    const {
      projectStatus, editProjectUrl, searchTalentUrl,
      projectType, proposalState, invitationsCount,
      projectInvitationsUrl, candidateName, profileUrl,
    } = this.props;

    if (projectStatus === 'employer_draft') {
      return (
        <div className="project-status-actions">
          <h2>Submit project draft for review</h2>
          <div className="mt-12 body-text-2">
            Clora will help you refine your project
            to succeed on our marketplace.
          </div>
          <div className="mt-32 text-center">
            <button
              id="submit-to-clora-status-button"
              className="btn btn-primary"
              onClick={() => this.handleSubmitToClora()}
            >
              Submit to Clora
            </button>
          </div>
          <div className="mt-16 text-center">
            <a
              id="edit-project-status-button"
              className="btn btn-secondary"
              href={editProjectUrl}
            >
              Edit Project
            </a>
          </div>
          <div className="mt-22 text-center">
            <button
              id="delete-project-status-button"
              className="btn btn-grey pt-0 pr-0 pb-0 pl-0"
              onClick={() => { if (window.confirm('Are you sure you want to delete this project?')) { this.handleDeleteProject(); } }}
            >
              <i className="fas fa-trash-alt me-3" />
              Delete Project
            </button>
          </div>
        </div>
      );
    } if (projectStatus === 'employer_requested_matching' && candidateName !== null) {
      const firstName = candidateName.split(' ')[0];

      return (
        <div className="project-status-actions">
          <h2>
            Waiting for
            {candidateName}
            &apos;s proposals.
          </h2>
          <div className="mt-12 body-text-2">
            You requested to hire
            {' '}
            {candidateName}
            {' '}
            for this project. Clora shared this info with them
            and will contact you shortly with an answer.
          </div>
          <div className="mt-32">
            <a
              id="profile-button"
              className="btn btn-primary"
              href={profileUrl}
            >
              {`View ${firstName}'s Profile`}
            </a>
          </div>
          <div className="mt-16">
            <a
              id="edit-project-status-button"
              className="btn btn-secondary"
              href={editProjectUrl}
            >
              Edit Project
            </a>
          </div>
        </div>
      );
    } if (projectStatus === 'employer_requested_matching' && projectType !== 'open_marketplace') {
      return (
        <div className="project-status-actions">
          <h2>Clora is reviewing your project</h2>
          <div className="mt-12 body-text-2">
            Your account manager will set up a call with you to refine this
            post before making it public to consultants.
          </div>
          <div className="mt-22 text-center">
            <button
              id="retract-project-status-button"
              className="btn btn-grey retract-submission pt-0 pr-0 pb-0 pl-0"
              onClick={() => this.handleRetractSubmission()}
            >
              <i className="fas fa-backward me-3" />
              Retract Submission
            </button>
          </div>
        </div>
      );
    } if (projectStatus === 'employer_requested_matching' && projectType === 'open_marketplace') {
      return (
        <div className="project-status-actions">
          <h2>Invite talent, wait for proposals</h2>
          { proposalState === 'no_proposals_submitted'
            && (
            <div className="mt-12 body-text-2">
              0 Proposals in. The more consultants you invite, the more proposals you receive.
            </div>
            )}
          { proposalState !== 'no_proposals_submitted'
            && (
            <div className="mt-12 body-text-2">
              Search for consultants, connect, and wait for their proposals.
            </div>
            )}
          <div className="mt-32">
            <a
              id="search-talent-status-button"
              className="btn btn-primary"
              href={searchTalentUrl}
            >
              Search Talent
            </a>
          </div>
          { proposalState === 'no_proposals_submitted'
            && (
            <div className="mt-16">
              <a
                id="edit-project-status-button"
                className="btn btn-secondary"
                href={editProjectUrl}
              >
                Edit Project
              </a>
            </div>
            )}
          { invitationsCount > 0
            && (
            <div className="mt-40">
              <hr />
              <div className="mt-40 body-text-1 demibold">
                <a
                  id="invitations-project-status-button"
                  className="btn btn-secondary-no-border"
                  href={projectInvitationsUrl}
                >
                  <span className="invitations">
                    <i className="fa fa-user-plus mr-8" />
                    Invitations
                  </span>
                  <span className="invitations-count">
                    {invitationsCount}
                    <i className="fa fa-angle-right ms-3" />
                  </span>
                </a>
              </div>
            </div>
            )}
        </div>
      );
    } if (projectStatus === 'clora_matching') {
      return (
        <div className="project-status-actions">
          <h2>Wait for candidates&#39; proposals.</h2>
          <div className="mt-12 body-text-2">
            Clora is identifying relevant candidates. You&#39;ll receive custom
            proposals from high-fit consultants.
          </div>
          <div className="mt-28 text-center">
            <img src={waitingImg} alt="Person sitting" className="waiting-image" />
          </div>
        </div>
      );
    }
    return null;
  }
}

ProjectStatusActions.propTypes = {
  projectStatus: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
  proposalState: PropTypes.string.isRequired,
  invitationsCount: PropTypes.number,
  csrfToken: PropTypes.string.isRequired,
  submitToCloraUrl: PropTypes.string.isRequired,
  editProjectUrl: PropTypes.string.isRequired,
  searchTalentUrl: PropTypes.string.isRequired,
  retractSubmissionUrl: PropTypes.string.isRequired,
  projectUrl: PropTypes.string.isRequired,
  projectsUrl: PropTypes.string.isRequired,
  projectInvitationsUrl: PropTypes.string,
  candidateName: PropTypes.string,
  profileUrl: PropTypes.string,
};

ProjectStatusActions.defaultProps = {
  invitationsCount: 0,
  projectInvitationsUrl: '',
  candidateName: null,
  profileUrl: null,
};

export default ProjectStatusActions;
